module.exports = __webpack_public_path__ + "static/media/unix_video.677089e3.gif";